import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'

export default function useEddExp(): {
  isEddExpEnabled: boolean
  experimentBucket: string
  isInitialized: boolean
} {
  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.EDD)

  return {
    isEddExpEnabled: experimentBucket !== STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.EDD].buckets?.control && init,
    experimentBucket: experimentBucket ?? '',
    isInitialized: init,
  }
}
